import { Ability } from '@/models/Ability';
import ability from './index';
import Permissions from './permissions';

// Rebuilds the live ability from the user's roles and permissions. The values
// are persisted as part of the user object (PERSISTED_USER_FIELDS), which is
// what CASL re-seeds from on the next cold start — see ability/index.ts.
export function updatePermissions(roles: string[], permissions: string[]) {
  const allPermissions = [] as Ability[];

  roles.forEach((role) => {
    allPermissions.push(...Permissions.rolePermissions[role] ?? []);
  });

  permissions.forEach((permission) => {
    allPermissions.push(...Permissions.additionalPermissions[permission] ?? []);
  });

  ability.update(allPermissions);
}

export function checkRoutePermissions(requiredPermissions: Ability[]): boolean {
  let result = false;

  requiredPermissions.forEach((permission) => {
    if (ability.can(permission.action, permission.subject)) result = true;
  });
  return result;
}
